export const checkMenhSim = (phoneNumber) => {
  if (phoneNumber) {
    const LogicTranhSo = (phoneNumber, sotranh) => {
      const intersections = phoneNumber.split('').filter((e) => sotranh.indexOf(parseInt(e)) !== -1);
      const bolSim = intersections.length > 0 ? false : true;
      return bolSim;
    };
    const tho3 = LogicTranhSo(phoneNumber.slice(-2), '0,1,3,4');
    const tho6 = LogicTranhSo(phoneNumber.slice(-3), '3,4');
    const kim3 = LogicTranhSo(phoneNumber.slice(-2), '3,4,9');
    const kim6 = LogicTranhSo(phoneNumber.slice(-3), '9');
    const hoa3 = LogicTranhSo(phoneNumber.slice(-2), '0,1,6,7');
    const hoa6 = LogicTranhSo(phoneNumber.slice(-3), '0,1');
    const thuy3 = LogicTranhSo(phoneNumber.slice(-2), '2,5,8,9');
    const thuy6 = LogicTranhSo(phoneNumber.slice(-3), '2,5,8');
    const moc3 = LogicTranhSo(phoneNumber.slice(-2), '2,5,6,7,8');
    const moc6 = LogicTranhSo(phoneNumber.slice(-3), '6,7');
    let simTho = '';
    let simKim = '';
    let simHoa = '';
    let simThuy = '';
    let simMoc = '';
    if (tho3 && tho6) {
      simTho = 'tho';
    }
    if (kim3 && kim6) {
      simKim = 'kim';
    }
    if (thuy3 && thuy6) {
      simThuy = 'thuy';
    }
    if (hoa3 && hoa6) {
      simHoa = 'hoa';
    }
    if (moc3 && moc6) {
      simMoc = 'moc';
    }

    // const totalSimOld = totalSim <= 9 ? totalSim : parseInt(totalSim.slice(0, 1) + totalSim.slice(1, 2));
    // console.log(totalSim, totalSimOld, totalSimFinal, simMenh, simHopTuoi);
    const arrMenhSim = [simTho, simKim, simThuy, simHoa, simMoc];
    var filtered = arrMenhSim.filter((item) => typeof item === 'string' && item !== '').join(',');
    return filtered.toString();
  }
};
